import type { FaireProductEntity } from "../../entity_types/product";

export const p_s5786364kd: FaireProductEntity = {
  token: "p_s5786364kd",
  type: "product",
  name: "KIDS MULTIVITAMIN ORAL SPRAY",
  brandToken: "b_899xeyfwqw",
  brandName: "SpectraSpray Global",
  imageUrl:
    "https://cdn.faire.com/fastly/715f637a7925dfcee5891bfc6ac68d020ebec6259ada5ef0540826931874d2b0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9fffe4a5b1de387f7467108086e86b34ea1dcb99f2cf860b3a11433afed4c25a.png",
    "https://cdn.faire.com/fastly/17e3a1fdf07c87127d7b074257e44ca54be7ddac1296537b999aad1d3a315ae4.jpeg",
    "https://cdn.faire.com/fastly/479f0014dfa9afcb5b9cd135b073ab3204f016a3e79d8f503916781428ee20ee.jpeg",
    "https://cdn.faire.com/fastly/9945c87bb1d79867b71c1b1633b5cef8a1f753fc9e051a2db5fe87e40f43345f.jpeg",
    "https://cdn.faire.com/fastly/b65717934f49beca14302ff5a8042ff48b3265a82a6df0e54d2821f6901d440a.jpeg",
  ],
  priceDollars: 13.96,
  description:
    "SpectraSpray™ KIDS' Multivitamin is easy to use and the kids will love the idea of using a spray; especially if their parents do too! Get up to 4X's higher absorption than gummies and chews that are subject to the digestive process.\n\nOral spray multi is a foundational vitamin that provides adequate nutrients, which are ready to absorb. JUST NUTRIENTS. JUST SPRAY. \n\nWe use fresh fruit flavor without artificial sugar or dyes: Great berry taste.\n\nFor ages 4 and older\nNo need for food or water\nB12 in its active form (MTHFR genetic friendly)\n500 IU D3 to support immune health\nDiabetic friendly\nImportant trace minerals for systemic support\nSugar, dye free\nPleasantly sweetened with xylitol/stevia\n\nWith oral spray delivery, you avoid many common problems with pills capsules, chewable and gummy formulations. Other forms can break apart before they are supposed to, or NOT break down in order to release the nutrients. With oral sprays, your child will receive ONLY NUTRIENTS.\n\n",
  tags: [],
  msrpDollars: 27.92,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:28.132Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
